module.exports = __webpack_public_path__ + "img/MK.9591decf.svg";